import React, { useMemo, useCallback } from 'react'
import PropTypes from 'prop-types'

import { useFormContext } from 'react-hook-form'
import { Grid } from '@mui/material'

import { HHFormSelectField, HHFormTextField, HHFormDesktopDatePicker } from 'components/form-fields/v5'
import { sortByStringSelector } from 'data/utils/sortByStringSelector'

import T from 'T'
import { CommonTextLabel } from 'components/common'

const BasicFields = ({ allSites = [] }) => {
  const { control, setValue, watch } = useFormContext()
  const materials = watch('materials')
  const allSitesSorted = useMemo(() => sortByStringSelector({ data: allSites, key: 'name' }), [allSites])

  const getOptionId = useCallback(option => option?.id, [])

  const getDisposalSiteOptionLabel = useCallback(option => option?.name, [])

  const handleDisposalSiteIdChange = () => {
    const newMaterials = materials.map(material => ({ ...material, disposalSiteMaterialId: '', unitOfMeasure: '' }))
    setValue('materials', newMaterials)
  }

  return (
    <>
      <Grid size={12}>
        <HHFormTextField
          fullWidth
          control={control}
          required
          rules={{ required: true }}
          name="ticketNumber"
          label={`${T.TICKET} #`}
          placeholder={T.ENTER_TICKET_NUMBER_PLACEHOLDER}
        />
      </Grid>
      <Grid size={12}>
        <CommonTextLabel title="Date" />
        <HHFormDesktopDatePicker name="effectiveDate" control={control} />
      </Grid>
      <Grid size={12}>
        <HHFormSelectField
          fullWidth
          control={control}
          required
          rules={{ required: true }}
          label={T.DISPOSAL_SITE}
          placeholder={T.DISPOSAL_SITE}
          options={allSitesSorted}
          getOptionValue={getOptionId}
          getOptionLabel={getDisposalSiteOptionLabel}
          name="disposalSiteId"
          onChange={handleDisposalSiteIdChange}
        />
      </Grid>
    </>
  )
}

BasicFields.propTypes = {
  allSites: PropTypes.array,
}

export default BasicFields
